export default __webpack_public_path__ + "static/media/Twitter.9fb19b9c.svg";